import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SocialUserSignUp } from 'app/shared/models/class/user/user';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UsersService } from 'app/shared/services/users/users.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  signUpForm: UntypedFormGroup;
  confirmSignUp = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private usersService: UsersService,
    public dialog: MatDialog,
    private uiService: UiService,
    private router: Router,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {

    const newUser = {
      firstname: this.f.firstname.value,
      lastname: this.f.lastname.value,
      email: this.f.email.value,
      phoneNumber: this.f.phoneNumber.value
    }


    this.usersService.signByMail(newUser).subscribe({
      next: () => {
        this.confirmSignUp = true;
        setTimeout(() => {
          this.confirmSignUp = false;
          this.router.navigate(['/home']);
        }, 3000);
      },
      error: (error) => {
        console.error("error", error);
        this.uiService.showSnackbar('Erreur: ' + error.error);
      }
    });

  }

  private initComponent(): void {
    this.dataService.tabHome$.next('other');
  }

  get f() {
    return this.signUpForm.controls;
  }

  private initForm(): void {
    this.signUpForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['']
    });
  }

}
